import App from '@/models/App'

export default class SelectShip extends App {
    static get entity() {
        return 'SelectShips'
    }
    static findById(id) {
        return this.query().whereId(id).withAllRecursive().first()
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static getNightTime() {
        const { night_time_from, night_time_to } = this.query().first()
        return { from: night_time_from || 22, to: night_time_to || 4 }
    }
    static fields() {
        return {
            id: this.attr(''),
            code: this.attr(''),
            display: this.attr(''),
            value: this.attr(''),
            night_time_from: this.attr(''),
            night_time_to: this.attr(''),
        }
    }
    static apiConfig = {
        actions: {
            fetch(organizationId) {
                return this.get(`/organizations/${organizationId}/ships`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.attendURL(),
                })
            },
        },
    }
}
